export default ":"